import React from 'react';
import { Trans } from 'react-i18next';
import { H3, Subtitle } from 'react-design-components';
import { Box } from '@material-ui/core';
import useHelp from './hooks/useHelp';

const HasLegalInsuranceHelp = () => {
  const { t } = useHelp();
  return (
    <Trans i18nKey="has_legal_insurance" t={t}>
      <Box mb={3}>
        <H3>Rechtsschutzversicherung</H3>
      </Box>

      <Box mb={2}>
        <Subtitle>
          MINEKO pflegt Partnerschaften zu einigen großen deutschen Rechtsschutzversicherern, darunter beispielsweise
          die ARAG, DEVK, R+V, WGV und einige weitere.
        </Subtitle>
      </Box>

      <Box mb={2}>
        <Subtitle>
          Diese Angabe ist für uns wichtig, da einige Versicherer die Kosten der Prüfung komplett übernehmen. Für Sie
          entstehen dadurch keinerlei Kosten.
        </Subtitle>
      </Box>
    </Trans>
  );
};

export default HasLegalInsuranceHelp;
